import { Form, SimpleItem, ButtonItem, EmptyItem, GroupItem } from "devextreme-react/form";
import { useEffect, useState, useCallback, useRef } from "react";
import { PostData } from "../../../Helper";
import { List, ItemDragging } from "devextreme-react/list";
import { TextBox } from "devextreme-react/text-box";
import { Button } from "devextreme-react/button";
const options = [
  { id: "a", name: "A" },
  { id: "b", name: "B" },
  { id: "c", name: "C" },
  { id: "d", name: "D" },
  { id: "e", name: "E" },
];

const TestQustionForm = ({
  questions,
  types,
  setPairWords,
  setPairFiles,
  setTypes,
  setQuestions,
  editFormData,
  setEditFormData,
  setShowQuestionForm,
  mode,
}) => {
  const [type, setType] = useState();
  const [pairMode, setPairMode] = useState(0);
  const [words, setWords] = useState([]);
  const [rightWords, setRightWords] = useState([]);
  const [word, setWord] = useState();
  const [files, setFiles] = useState([]);
  const [rightFiles, setRightFiles] = useState([]);
  const [formData, setFormData] = useState({});
  const [no, setNo] = useState(0);
  useEffect(() => {
    setFormData({ ...editFormData });
  }, [editFormData, setEditFormData]);
  useEffect(() => {
    setNo(questions.length + 1);
  }, [questions]);
  const formRef = useRef();

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (type == 3 && pairMode === 0) {
        if (rightWords.length != words.length) {
          return window.toastr.warning("ada Soal menjodohkan yang tidak memiliki pasangan");
        } else {
          for (let index = 0; index < words.length; index++) {
            const left = words[index];
            const right = rightWords[index];
            setPairWords((prev) => [...prev, { left: left, right: right, mode: mode, no: no }]);
          }
        }
      }
      if (type == 3 && pairMode === 1) {
        if (rightFiles.length != files.length) {
          return window.toastr.warning("ada Gambar menjodohkan yang tidak memiliki pasangan");
        } else {
          for (let index = 0; index < files.length; index++) {
            const left = files[index];
            const right = rightFiles[index];
            setPairFiles((prev) => [...prev, { left: left, right: right, mode: mode, no: no }]);
          }
        }
      }

      setShowQuestionForm(false);

      if (mode == 1) {
        setQuestions((prev) => [...prev, formData]);
      } else if (mode == 2) {
        const newQuestions = [...questions];
        const index = newQuestions.findIndex((e) => e.id === formData.id);
        newQuestions[index] = formData;
        setQuestions((_) => newQuestions);
      }

      setFormData({});
      setRightFiles([]);
      setFiles([]);
      setRightWords([]);
      setWords([]);
    },
    [formData, setFormData, setQuestions, questions, files, rightFiles, rightWords, setWords, setRightWords, words, setNo, no]
  );
  const onDragStart = useCallback(
    (e) => {
      e.itemData = e.fromData === "left" ? words[e.fromIndex] : rightWords[e.fromIndex];
    },
    [words, rightWords]
  );

  const onAdd = useCallback(
    (e) => {
      const tasks = e.toData === "left" ? words : rightWords;
      const updatedTasks = [...tasks.slice(0, e.toIndex), e.itemData, ...tasks.slice(e.toIndex)];

      if (e.toData === "left") {
        setWords(updatedTasks);
      } else {
        setRightWords(updatedTasks);
      }
    },
    [setWords, setRightWords, words, rightWords]
  );

  const onRemove = useCallback(
    (e) => {
      const tasks = e.fromData === "left" ? words : rightWords;
      const updatedTasks = [...tasks.slice(0, e.fromIndex), ...tasks.slice(e.fromIndex + 1)];

      if (e.fromData === "left") {
        setWords(updatedTasks);
      } else {
        setRightWords(updatedTasks);
      }
    },
    [setWords, setRightWords, words, rightWords]
  );

  const onReorder = useCallback(
    (e) => {
      onRemove(e);
      onAdd(e);
    },
    [onAdd, onRemove]
  );

  const onFileDragStart = useCallback(
    (e) => {
      e.itemData = e.fromData === "fileLeft" ? files[e.fromIndex] : rightFiles[e.fromIndex];
    },
    [files, rightFiles]
  );

  const onFileAdd = useCallback(
    (e) => {
      const tasks = e.toData === "fileLeft" ? files : rightFiles;
      const updatedTasks = [...tasks.slice(0, e.toIndex), e.itemData, ...tasks.slice(e.toIndex)];

      if (e.toData === "fileLeft") {
        setFiles(updatedTasks);
      } else {
        setRightFiles(updatedTasks);
      }
    },
    [setFiles, setRightFiles, files, rightFiles]
  );

  const onFileRemove = useCallback(
    (e) => {
      const tasks = e.fromData === "fileLeft" ? files : rightFiles;
      const updatedTasks = [...tasks.slice(0, e.fromIndex), ...tasks.slice(e.fromIndex + 1)];

      if (e.fromData === "fileLeft") {
        setFiles(updatedTasks);
      } else {
        setRightFiles(updatedTasks);
      }
    },
    [setFiles, setRightFiles, files, rightFiles]
  );

  const onFileReorder = useCallback(
    (e) => {
      if (e.fromData == e.toData) {
        if (e.fromIndex == e.toIndex) return;
        const items = e.fromData === "fileLeft" ? [...files] : [...rightFiles];
        const temp = items[e.fromIndex];
        items[e.fromIndex] = items[e.toIndex];
        items[e.toIndex] = temp;
        if (e.fromData === "fileLeft") {
          setFiles(items);
        } else {
          setRightFiles(items);
        }
      } else {
        onFileRemove(e);
        onFileAdd(e);
      }
    },
    [onFileAdd, onFileRemove]
  );

  const listImage = (e) => {
    const src = URL.createObjectURL(e);

    return (
      <div>
        <img src={src} height={64} width={64} />
        <div>{e.name}</div>
      </div>
    );
  };
  return (
    <form className="p-4  row" action="" onSubmit={handleSubmit}>
      <Form formData={formData} className="row col-md-6 mr-2" colCount={4} labelLocation="top" ref={formRef}>
        <SimpleItem
          dataField="no"
          isRequired={true}
          label={{ text: "No." }}
          editorOptions={{ value: no }}
          editorType="dxNumberBox"
          colSpan={1}
          disabled={true}
        />
        <SimpleItem
          dataField="question_type_id"
          label={{ text: "Jenis Pertanyaan" }}
          editorType="dxSelectBox"
          editorOptions={{
            displayExpr: "name",
            valueExpr: "id",
            dataSource: types,

            onValueChanged: (e) => {
              setType(e.value);
            },
          }}
          colSpan={3}
        />
        <SimpleItem
          dataField="question"
          label={{ text: "Pertanyaan" }}
          editorType="dxTextArea"
          editorOptions={{ maxLength: 100 }}
          isRequired={true}
          colSpan={4}
        />
        <SimpleItem dataField="option_a" label={{ text: "Pilihan A" }} isRequired={type === 1} colSpan={2} visible={type === 1} />
        <SimpleItem dataField="option_b" label={{ text: "Pilihan B" }} isRequired={type === 1} colSpan={2} visible={type === 1} />
        <SimpleItem dataField="option_c" label={{ text: "Pilihan C" }} isRequired={type === 1} colSpan={2} visible={type === 1} />
        <SimpleItem dataField="option_d" label={{ text: "Pilihan D" }} isRequired={type === 1} colSpan={2} visible={type === 1} />
        <SimpleItem dataField="option_e" label={{ text: "Pilihan E" }} isRequired={type === 1} colSpan={2} visible={type === 1} />
        <SimpleItem
          dataField="answer_multiple"
          label={{ text: "Jawaban Pilihan Ganda" }}
          editorType="dxRadioGroup"
          editorOptions={{
            items: options,
            valueExpr: "id",

            displayExpr: "name",
            layout: "horizontal",
          }}
          colSpan={2}
          isRequired={type == 1}
          visible={type === 1}
        />
        <SimpleItem
          dataField="answer_true_false"
          editorType="dxRadioGroup"
          label={{ text: `Jawaban` }}
          editorOptions={{
            items: [
              { id: 0, name: "Salah" },
              { id: 1, name: "Benar" },
            ],
            valueExpr: "id",
            displayExpr: "name",
            layout: "horizontal",
            defaultValue: 0,
          }}
          colSpan={4}
          visible={type === 2}
          isRequired={type === 2}
        />
        <SimpleItem
          dataField="answer_fill"
          editorType="dxTextArea"
          label={{ text: `Jawaban Isian` }}
          colSpan={4}
          visible={type === 4}
          isRequired={type === 4}
        />
        <SimpleItem
          dataField="answer_essay"
          editorType="dxTextArea"
          label={{ text: `Jawaban ESAY` }}
          colSpan={4}
          visible={type === 5}
          isRequired={type === 5}
        />
        <SimpleItem
          dataField="pair_mode"
          editorType="dxRadioGroup"
          label={{ text: `Tipe =  ${pairMode === 0 ? "Kata" : "Gambar"}` }}
          editorOptions={{
            items: [
              { id: 0, name: "Kata" },
              { id: 1, name: "Gambar" },
            ],
            valueExpr: "id",
            displayExpr: "name",
            layout: "horizontal",
            defaultValue: 0,
            value: pairMode,
            onValueChanged: (e) => setPairMode(e.value),
          }}
          colSpan={4}
          visible={type === 3}
          isRequired={type === 3}
        />
      </Form>

      <div className="row col-md-6   ">
        <div className="d-flex p-2">
          <TextBox
            width="300px"
            dataField="word"
            className="mb-2"
            onValueChanged={(e) => setWord(e.value)}
            colSpan={1}
            visible={type === 3 && pairMode === 0}
          />
          <Button
            text="Tambah kata"
            type="default"
            stylingMode="outlined"
            width="120px"
            className="ml-2"
            visible={type === 3 && pairMode === 0}
            onClick={(e) => {
              if ((words.length + rightWords.length) % 2 === 0) {
                setWords((prev) => [...prev, word]);
              } else {
                setRightWords((prev) => [...prev, word]);
              }
            }}
          />
        </div>

        {type === 3 && pairMode === 1 && (
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => {
              const files = [...e.target.files];
              const midpoint = Math.ceil(files.length / 2);

              const firstHalf = files.slice(0, midpoint);
              const secondHalf = files.slice(midpoint);
              setFiles(firstHalf);
              setRightFiles(secondHalf);
            }}
          />
        )}

        {type === 3 && pairMode === 1 && (
          <div className="row mb-2 p-4    overflow-auto">
            <List
              itemRender={listImage}
              allowItemDeleting={true}
              allowReordering={true}
              visible={type === 3 && pairMode === 1}
              className="col-md-6 border  p-2"
              dataSource={files}
              showScrollbar="always"
            >
              <ItemDragging
                allowReordering={true}
                onAdd={onFileAdd}
                onRemove={onFileRemove}
                onReorder={onFileReorder}
                onDragStart={onFileDragStart}
                group="images"
                data="fileLeft"
              />
            </List>
            <List
              itemRender={listImage}
              allowItemDeleting={true}
              allowReordering={true}
              visible={type === 3 && pairMode === 1}
              className="col-md-6 border  p-2"
              dataSource={rightFiles}
              showScrollbar="always"
            >
              <ItemDragging
                allowReordering={true}
                onAdd={onFileAdd}
                onRemove={onFileRemove}
                onReorder={onFileReorder}
                onDragStart={onFileDragStart}
                group="images"
                data="fileRight"
              />
            </List>
          </div>
        )}
        {type === 3 && pairMode === 0 && (
          <div className="row mb-2   ">
            <List keyExpr="id" allowItemDeleting={true} visible={type === 3 && pairMode === 0} className="col-md-6 border  p-2" dataSource={words}>
              <ItemDragging
                allowReordering={true}
                onAdd={onAdd}
                onRemove={onRemove}
                onReorder={onReorder}
                onDragStart={onDragStart}
                group="words"
                data="left"
              />
            </List>
            <List
              keyExpr="id"
              allowItemDeleting={true}
              visible={type === 3 && pairMode === 0}
              className="col-md-6 border  p-2"
              dataSource={rightWords}
            >
              <ItemDragging
                allowReordering={true}
                onAdd={onAdd}
                onRemove={onRemove}
                onReorder={onReorder}
                onDragStart={onDragStart}
                group="words"
                data="right"
              />
            </List>
          </div>
        )}
      </div>
      <div className=" mt-4 col-md-12">
        <Button useSubmitBehavior={true} height="48px" text="Simpan" type="default" width="300px" />
      </div>
    </form>
  );
};

export default TestQustionForm;
